export default "__VITE_ASSET__cd1cc124__"